import { render, staticRenderFns } from "./ModalAddPayItemV2.vue?vue&type=template&id=6854770a"
import script from "./ModalAddPayItemV2.vue?vue&type=script&lang=js"
export * from "./ModalAddPayItemV2.vue?vue&type=script&lang=js"
import style0 from "./ModalAddPayItemV2.vue?vue&type=style&index=0&id=6854770a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports